import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ITabButton {
  theme: ITheme;
  isSelected?: boolean;
}

export const TabsCont = styled.div`
  position: relative;
  align-self: center;
  display: flex;
  width: fit-content;
  ${({ theme }: IThemeProvider) => `
    margin-top: ${theme.layout.spacing.mikro};
    border: 2px solid ${theme.colors.secondary[70]};
    border-radius: ${theme.layout.spacing.nano};
    background: ${theme.colors.neutral.primary[0]};
  `}
`;

export const TabButton = styled.div`
  font-size: 16px;
  line-height: 19px;
  padding: 10.5px 24px;
  border: none;
  cursor: pointer;

  ${({ theme, isSelected }: ITabButton) => `
    border-radius: ${theme.layout.spacing.piko};
    background: ${isSelected ? theme.colors.secondary[100] : 'transparent'};
    color: ${isSelected ? 'white' : theme.colors.secondary[100]};
    font-weight: ${isSelected ? '700' : '400'};
  `}
`;

export const TabGroupSectionCont = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
`;
